import Constants from '../utils/constants';

const SIGNAL_CHAIN_ITEMS = Constants.SIGNAL_CHAIN_ITEMS;
const APP_PARAMS = Constants.APP_PARAMS;
const TOPOLOGY_INPUTS = Constants.TOPOLOGY_INPUTS;
const RESISTORS = Constants.RESISTORS;
const RESISTOR_PARAMS = Constants.RESISTOR_PARAMS;

const dac = {
    key: 'dac',
    inModel: true,
    location: 'signalChainHandler.dac.selected.name',
    handler: 'handleDacChange',
  },
  dacType = {
    key: 'dt',
    inModel: true,
    requiredForLoad: true,
    location: 'signalChainHandler.dac.type.id',
    handler: 'handleDacTypeChange',
  },
  tab = {
    key: 'tab',
    inModel: false,
    location: 'tabService.selected.index',
    handler: 'handleTabChange',
  },
  errorData = {
    key: 'ed',
    inModel: true,
    location: 'signalChainHandler.errorData',
    handler: 'handleObjectChange',
    isObject: true,
  };

let signalChain = {};
signalChain.hasMultipleInOneLocation = true;
signalChain.inModel = true;
signalChain.location = 'signalChainHandler.availableItems';
signalChain.itemLocation = 'selected.name';
signalChain.itemHandler = 'handleSignalChainChange';
signalChain.items = {};
signalChain.items[SIGNAL_CHAIN_ITEMS.VOLTAGE_REFERENCE] = { key: 'scvr' };
signalChain.items[SIGNAL_CHAIN_ITEMS.INVERTING_AMP] = { key: 'scia' };
signalChain.items[SIGNAL_CHAIN_ITEMS.INVERTING_BUFFER] = { key: 'scib' };
signalChain.items[SIGNAL_CHAIN_ITEMS.NON_INVERTING_AMP] = { key: 'scnia' };
signalChain.items[SIGNAL_CHAIN_ITEMS.NON_INVERTING_BUFFER] = { key: 'scnib' };
signalChain.items[SIGNAL_CHAIN_ITEMS.OUTPUT_AMP] = { key: 'scoa' };
signalChain.items[SIGNAL_CHAIN_ITEMS.OUTPUT_BUFFER] = { key: 'scob' };
signalChain.items[SIGNAL_CHAIN_ITEMS.BUFFER] = { key: 'scb' };

let appParameter = {};
appParameter.hasMultiple = true;
appParameter.inModel = true;
appParameter.items = {};
appParameter.items[APP_PARAMS.MIN_OPERATING_TEMP] = {
  key: 'apminot',
  handler: 'handleNumericInputChange',
  location: 'signalChainHandler.dac.data.operatingTemperature.min',
};
appParameter.items[APP_PARAMS.MAX_OPERATING_TEMP] = {
  key: 'apmaxot',
  handler: 'handleNumericInputChange',
  location: 'signalChainHandler.dac.data.operatingTemperature.max',
};
appParameter.items[APP_PARAMS.POWER_SUPPLY_RIPPLE] = {
  key: 'appsr',
  handler: 'handleNumericInputChange',
  location: 'signalChainHandler.dac.data.powerSupplyRipple',
};
appParameter.items[APP_PARAMS.CALIBRATION] = {
  key: 'appcal',
  handler: 'handleBooleanInputChange',
  location: 'signalChainHandler.dac.data.calibrationToggled',
};

let topologyInput = {};
topologyInput.hasMultipleInOneLocation = true;
topologyInput.inModel = true;
topologyInput.location = 'topologyInputHandler.current';
topologyInput.itemLocation = 'selectedOption.id';
topologyInput.itemHandler = 'handleTopologyChange';
topologyInput.items = {};
topologyInput.items[TOPOLOGY_INPUTS.MULTIPLYING_DAC] = { key: 'timd' };
topologyInput.items[TOPOLOGY_INPUTS.VOLTAGE_REFERENCE] = { key: 'tivr' };
topologyInput.items[TOPOLOGY_INPUTS.NON_INVERTING] = { key: 'tini' };
topologyInput.items[TOPOLOGY_INPUTS.INVERTING] = { key: 'tii' };
topologyInput.items[TOPOLOGY_INPUTS.OUTPUT] = { key: 'tio' };
topologyInput.items[TOPOLOGY_INPUTS.IOUT_OR_VOUT] = { key: 'tiiv' };
topologyInput.items[TOPOLOGY_INPUTS.RSET] = { key: 'tir' };
topologyInput.items[TOPOLOGY_INPUTS.OUTPUT_RANGE] = { key: 'tior' };

let resistorInput = {};
resistorInput.hasMultipleInOneLocation = true;
resistorInput.inModel = true;
resistorInput.location = 'resistorHandler.availableResistors';
resistorInput.items = {};

resistorInput.items[RESISTORS.INVERTING] = {};
resistorInput.items[RESISTORS.INVERTING].hasMultiple = true;
resistorInput.items[RESISTORS.INVERTING].items = {};
resistorInput.items[RESISTORS.INVERTING].items[RESISTOR_PARAMS.R1] = {
  key: 'rir1',
  handler: 'handleNumericInputChange',
  location: 'values.res1',
  saveLocation: 'res1',
};
resistorInput.items[RESISTORS.INVERTING].items[RESISTOR_PARAMS.R2] = {
  key: 'rir2',
  handler: 'handleNumericInputChange',
  location: 'values.res2',
  saveLocation: 'res2',
};
resistorInput.items[RESISTORS.INVERTING].items[RESISTOR_PARAMS.TOLERANCE] = {
  key: 'rito',
  handler: 'handleNumericInputChange',
  location: 'values.tolerance',
  saveLocation: 'tolerance',
};

resistorInput.items[RESISTORS.NON_INVERTING] = {};
resistorInput.items[RESISTORS.NON_INVERTING].hasMultiple = true;
resistorInput.items[RESISTORS.NON_INVERTING].items = {};
resistorInput.items[RESISTORS.NON_INVERTING].items[RESISTOR_PARAMS.R3] = {
  key: 'rnir3',
  handler: 'handleNumericInputChange',
  location: 'values.res1',
  saveLocation: 'res1',
};
resistorInput.items[RESISTORS.NON_INVERTING].items[RESISTOR_PARAMS.R4] = {
  key: 'rnir4',
  handler: 'handleNumericInputChange',
  location: 'values.res2',
  saveLocation: 'res2',
};
resistorInput.items[RESISTORS.NON_INVERTING].items[RESISTOR_PARAMS.TOLERANCE] = {
  key: 'rnito',
  handler: 'handleNumericInputChange',
  location: 'values.tolerance',
  saveLocation: 'tolerance',
};

resistorInput.items[RESISTORS.OUTPUT] = {};
resistorInput.items[RESISTORS.OUTPUT].hasMultiple = true;
resistorInput.items[RESISTORS.OUTPUT].items = {};
resistorInput.items[RESISTORS.OUTPUT].items[RESISTOR_PARAMS.R5] = {
  key: 'ror5',
  handler: 'handleNumericInputChange',
  location: 'values.res1',
  saveLocation: 'res1',
};
resistorInput.items[RESISTORS.OUTPUT].items[RESISTOR_PARAMS.R6] = {
  key: 'ror6',
  handler: 'handleNumericInputChange',
  location: 'values.res2',
  saveLocation: 'res2',
};
resistorInput.items[RESISTORS.OUTPUT].items[RESISTOR_PARAMS.TOLERANCE] = {
  key: 'roto',
  handler: 'handleNumericInputChange',
  location: 'values.tolerance',
  saveLocation: 'tolerance',
};

resistorInput.items[RESISTORS.EXTERNAL_RSET] = {};
resistorInput.items[RESISTORS.EXTERNAL_RSET].hasMultiple = true;
resistorInput.items[RESISTORS.EXTERNAL_RSET].items = {};
resistorInput.items[RESISTORS.EXTERNAL_RSET].items[RESISTOR_PARAMS.R] = {
  key: 'rrr',
  handler: 'handleNumericInputChange',
  location: 'values.res1',
  saveLocation: 'res1',
};
resistorInput.items[RESISTORS.EXTERNAL_RSET].items[RESISTOR_PARAMS.TOLERANCE] = {
  key: 'rrto',
  handler: 'handleNumericInputChange',
  location: 'values.tolerance',
  saveLocation: 'tolerance',
};
resistorInput.items[RESISTORS.EXTERNAL_RSET].items[RESISTOR_PARAMS.TEMPCO] = {
  key: 'rrte',
  handler: 'handleNumericInputChange',
  location: 'values.tempco',
  saveLocation: 'tempco',
};

// TODO: do we need this in the url?
// let errorParameter = {};
// errorParameter[ERROR_PARAMS] = {'ete'};

export default {
  // order matters
  configs: [
    dacType,
    dac,
    topologyInput,
    signalChain,
    resistorInput,
    appParameter,
    tab,
    errorData,
    //this.errorParameter
  ],
};
